import React from 'react';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import FilesRender from '../../../components/atoms/FilesRender';
const OwnerDetail = ({ form, handleChange, handleFileChange }) => {
  return (
    <Row>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner Name" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerName"
            value={form.ownerName}
            onChange={handleChange}
            type="text"
            placeholder="Owner Name"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner Email" className="mb-3">
          <Form.Control
            className="input"
            name="ownerEmail"
            value={form.ownerEmail}
            onChange={handleChange}
            type="email"
            placeholder="Owner Email"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner Phone No" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerPhoneNo"
            value={form.ownerPhoneNo}
            onChange={handleChange}
            type="text"
            placeholder="Owner Phone No"
          />
        </FloatingLabel>
      </Col>
      <Col xs={12}>
        <FloatingLabel controlId="floatingInput" label="Owner Address" className="mb-3">
          <Form.Control
            required
            as="textarea"
            className="input"
            name="ownerAddress"
            value={form.ownerAddress}
            onChange={handleChange}
            type="text"
            placeholder="Owner Address"
            style={{ height: '80px' }}
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner Account Number" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerAccountNumber"
            value={form.ownerAccountNumber}
            onChange={handleChange}
            type="text"
            placeholder="Owner Account Number"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner IFSC" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerIfsc"
            value={form.ownerIfsc}
            onChange={handleChange}
            type="text"
            placeholder="Owner IFSC"
          />
        </FloatingLabel>
      </Col>
      <Col xs={4}>
        <FloatingLabel controlId="floatingInput" label="Owner Bank Name" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerBankName"
            value={form.ownerBankName}
            onChange={handleChange}
            type="text"
            placeholder="Owner Bank Name"
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Owner PAN No" className="mb-3">
          <Form.Control
            required
            className="input"
            name="ownerPanNo"
            value={form.ownerPanNo}
            onChange={handleChange}
            type="text"
            placeholder="Owner PAN No"
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <Form.Label>Upload PAN Card Image</Form.Label>
        <Form.Control className="input mb-3" name="ownerPanImage" onChange={handleFileChange} type="file" required autoComplete="false" />
        {FilesRender(form['ownerPanImage'])}
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Owner AADHAR No" className="mb-3">
          <Form.Control
            className="input"
            name="ownerAadharNo"
            value={form.ownerAadharNo}
            onChange={handleChange}
            type="text"
            placeholder="Owner AADHAR No"
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <Form.Label>Upload Aadhar Card Images</Form.Label>
        <Form.Control
          className="input mb-3"
          name="ownerAadharImages"
          onChange={handleFileChange}
          type="file"
          multiple
          required
          autoComplete="false"
        />
        {FilesRender(form['ownerAadharImages'])}
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Owner Rent Sharing Percentage (0-100%)" className="mb-3">
          <Form.Control
            className="input"
            name="rentShareInPercent"
            value={form.rentShareInPercent}
            onChange={handleChange}
            type="number"
            placeholder="Enter 100% if only one owner."
          />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <Form.Label>Upload Cancelled Cheque</Form.Label>
        <Form.Control
          className="input mb-3"
          name="cancelledChequeImage"
          onChange={handleFileChange}
          type="file"
          required
          autoComplete="false"
        />
        {FilesRender(form['cancelledChequeImage'])}
      </Col>
    </Row>
  );
};

export default OwnerDetail;
